<article
  class="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 px-4 py-10 text-slate-800 sm:px-6"
>
  <div class="mx-auto max-w-3xl">
    <nav class="mb-8 text-sm">
      <a routerLink="/" class="font-medium text-green-600 hover:text-green-700">← WhatsMeApp</a>
    </nav>

    @switch (slug()) {
      @case ("como") {
        <h1 class="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          Como criar link do WhatsApp (guia completo)
        </h1>
        <p class="mt-6 leading-7 text-slate-600">Para criar um link de WhatsApp, use o formato:</p>
        <pre
          class="mt-3 overflow-x-auto rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-800"
        ><code>https://wa.me/SEUNUMERO</code></pre>
        <p class="mt-6 leading-7 text-slate-600">Exemplo:</p>
        <pre
          class="mt-3 overflow-x-auto rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-800"
        ><code>https://wa.me/5511999999999</code></pre>
        <h2 class="mt-10 text-xl font-semibold text-slate-900">Como adicionar mensagem automática</h2>
        <p class="mt-4 leading-7 text-slate-600">Você pode incluir uma mensagem assim:</p>
        <pre
          class="mt-3 overflow-x-auto rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-800"
        ><code>https://wa.me/5511999999999?text=Ola%20quero%20informacoes</code></pre>
        <p class="mt-6 leading-7 text-slate-600">Use nossa ferramenta para gerar automaticamente:</p>
        <p class="mt-4">
          <a
            routerLink="/"
            class="inline-flex rounded-2xl bg-green-500 px-5 py-3 font-semibold text-white shadow hover:bg-green-600"
          >
            Gerar link WhatsApp grátis
          </a>
        </p>
      }
      @case ("mensagem") {
        <h1 class="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          Gerar link WhatsApp com mensagem automática
        </h1>
        <p class="mt-6 leading-7 text-slate-600">
          Você pode criar links de WhatsApp já com mensagem pronta.
        </p>
        <p class="mt-4 leading-7 text-slate-600">Exemplo:</p>
        <pre
          class="mt-3 overflow-x-auto rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-800"
        ><code>https://wa.me/5511999999999?text=Quero%20comprar</code></pre>
        <p class="mt-6 leading-7 text-slate-600">Use nossa ferramenta para facilitar:</p>
        <p class="mt-4">
          <a
            routerLink="/"
            class="inline-flex rounded-2xl bg-green-500 px-5 py-3 font-semibold text-white shadow hover:bg-green-600"
          >
            Criar link agora
          </a>
        </p>
      }
      @case ("gerador") {
        <h1 class="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          Gerador de link WhatsApp grátis
        </h1>
        <p class="mt-6 leading-7 text-slate-600">
          Nosso gerador permite criar links de WhatsApp personalizados rapidamente.
        </p>
        <ul class="mt-6 list-disc space-y-2 pl-6 text-slate-600">
          <li>Adicionar mensagem automática</li>
          <li>Funciona em celular e desktop</li>
          <li>Totalmente gratuito</li>
        </ul>
        <p class="mt-8">
          <a
            routerLink="/"
            class="inline-flex rounded-2xl bg-green-500 px-5 py-3 font-semibold text-white shadow hover:bg-green-600"
          >
            Gerar meu link
          </a>
        </p>
      }
      @case ("como-en") {
        <h1 class="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          How to Create a WhatsApp Link (complete guide)
        </h1>
        <p class="mt-6 leading-7 text-slate-600">To create a WhatsApp link, use the format:</p>
        <pre class="mt-3 overflow-x-auto rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-800"><code>https://wa.me/YOURNUMBER</code></pre>
        <p class="mt-6 leading-7 text-slate-600">Example:</p>
        <pre class="mt-3 overflow-x-auto rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-800"><code>https://wa.me/15551234567</code></pre>
        <h2 class="mt-10 text-xl font-semibold text-slate-900">How to add an automatic message</h2>
        <p class="mt-4 leading-7 text-slate-600">You can include a message like this:</p>
        <pre class="mt-3 overflow-x-auto rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-800"><code>https://wa.me/15551234567?text=Hi%20I%20want%20more%20info</code></pre>
        <p class="mt-6 leading-7 text-slate-600">Use our tool to generate it automatically:</p>
        <p class="mt-4">
          <a routerLink="/" class="inline-flex rounded-2xl bg-green-500 px-5 py-3 font-semibold text-white shadow hover:bg-green-600">
            Generate WhatsApp link free
          </a>
        </p>
      }
      @case ("message-en") {
        <h1 class="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          WhatsApp Link with Automatic Message
        </h1>
        <p class="mt-6 leading-7 text-slate-600">You can create WhatsApp links with a preset message already included.</p>
        <p class="mt-4 leading-7 text-slate-600">Example:</p>
        <pre class="mt-3 overflow-x-auto rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-800"><code>https://wa.me/15551234567?text=I%20want%20to%20buy</code></pre>
        <p class="mt-6 leading-7 text-slate-600">Use our tool to make it easy:</p>
        <p class="mt-4">
          <a routerLink="/" class="inline-flex rounded-2xl bg-green-500 px-5 py-3 font-semibold text-white shadow hover:bg-green-600">
            Create link now
          </a>
        </p>
      }
      @case ("generator-en") {
        <h1 class="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          Free WhatsApp Link Generator
        </h1>
        <p class="mt-6 leading-7 text-slate-600">Our generator lets you create custom WhatsApp links quickly.</p>
        <ul class="mt-6 list-disc space-y-2 pl-6 text-slate-600">
          <li>Add automatic message</li>
          <li>Works on mobile and desktop</li>
          <li>Completely free</li>
        </ul>
        <p class="mt-8">
          <a routerLink="/" class="inline-flex rounded-2xl bg-green-500 px-5 py-3 font-semibold text-white shadow hover:bg-green-600">
            Generate my link
          </a>
        </p>
      }
      @case ("como-es") {
        <h1 class="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          Cómo crear enlace de WhatsApp (guía completa)
        </h1>
        <p class="mt-6 leading-7 text-slate-600">Para crear un enlace de WhatsApp, usa el formato:</p>
        <pre class="mt-3 overflow-x-auto rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-800"><code>https://wa.me/TUNUMERO</code></pre>
        <p class="mt-6 leading-7 text-slate-600">Ejemplo:</p>
        <pre class="mt-3 overflow-x-auto rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-800"><code>https://wa.me/525512345678</code></pre>
        <h2 class="mt-10 text-xl font-semibold text-slate-900">Cómo añadir mensaje automático</h2>
        <p class="mt-4 leading-7 text-slate-600">Puedes incluir un mensaje así:</p>
        <pre class="mt-3 overflow-x-auto rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-800"><code>https://wa.me/525512345678?text=Hola%20quiero%20informacion</code></pre>
        <p class="mt-6 leading-7 text-slate-600">Usa nuestra herramienta para generarlo automáticamente:</p>
        <p class="mt-4">
          <a routerLink="/" class="inline-flex rounded-2xl bg-green-500 px-5 py-3 font-semibold text-white shadow hover:bg-green-600">
            Generar enlace WhatsApp gratis
          </a>
        </p>
      }
      @case ("mensaje-es") {
        <h1 class="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          Generar enlace WhatsApp con mensaje automático
        </h1>
        <p class="mt-6 leading-7 text-slate-600">Puedes crear enlaces de WhatsApp ya con mensaje listo.</p>
        <p class="mt-4 leading-7 text-slate-600">Ejemplo:</p>
        <pre class="mt-3 overflow-x-auto rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-800"><code>https://wa.me/525512345678?text=Quiero%20comprar</code></pre>
        <p class="mt-6 leading-7 text-slate-600">Usa nuestra herramienta para facilitar el proceso:</p>
        <p class="mt-4">
          <a routerLink="/" class="inline-flex rounded-2xl bg-green-500 px-5 py-3 font-semibold text-white shadow hover:bg-green-600">
            Crear enlace ahora
          </a>
        </p>
      }
      @case ("generador-es") {
        <h1 class="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          Generador de enlace WhatsApp gratis
        </h1>
        <p class="mt-6 leading-7 text-slate-600">Nuestro generador te permite crear enlaces de WhatsApp personalizados rápidamente.</p>
        <ul class="mt-6 list-disc space-y-2 pl-6 text-slate-600">
          <li>Añadir mensaje automático</li>
          <li>Funciona en móvil y escritorio</li>
          <li>Totalmente gratuito</li>
        </ul>
        <p class="mt-8">
          <a routerLink="/" class="inline-flex rounded-2xl bg-green-500 px-5 py-3 font-semibold text-white shadow hover:bg-green-600">
            Generar mi enlace
          </a>
        </p>
      }
    }
  </div>
</article>
